export enum ApplicationRoute {
    NULL = '',
    PRODUCT_INFORMATION = 'product-information',
    LOGIN = 'login',
    LOGOUT = 'logout',
    ENTITLEMENTS = 'entitlements',
    DEPLOYMENT_DETAILS = 'deployment-details',
    ACCOUNT_SELECTED = 'accountselected',
    ACCOUNT_SELECTION = 'account-selection',
    SPLASH = 'splash',
    ADMIN = 'admin',
    ADMIN_SPLASH = ApplicationRoute.ADMIN + "/" + ApplicationRoute.SPLASH,
    DEPLOYMENTS = 'deployments',
}
